import { render, staticRenderFns } from "./HuntingWordsList.vue?vue&type=template&id=2ba1cd46"
import script from "./HuntingWordsList.vue?vue&type=script&lang=js"
export * from "./HuntingWordsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports